import { colors } from "@material-ui/core";
import createPalette from "@material-ui/core/styles/createPalette";

const white = "#FFFFFF";

export default createPalette({
  primary: {
    contrastText: white,
    dark: colors.indigo[900],
    main: colors.indigo[500],
    light: colors.indigo[100],
  },
  secondary: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue.A700,
    light: colors.blue.A400,
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
    subtle: colors.red[50],
    bright: "#f17987",
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400],
    subtle: "#dff8f2",
    bright: "#61dabf",
  },
  warning: {
    contrastText: white,
    dark: "#7c7c02",
    main: colors.yellow[600],
    light: colors.yellow[400],
    subtle: "#f9fec2",
    bright: "#ddb431",
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    // TODO: Is this actually used anywhere? If not, perhaps we do not need this `link` entry. `text.link` doesn't
    // appear to be a valid entry in the Material UI palette.
    // @ts-ignore
    link: colors.blue[600],
  },
  link: colors.blue[800],
  icon: colors.blueGrey[600],
  background: {
    default: "#F4F6F8",
    paper: white,
  },
  divider: colors.grey[200],
});
